import React from 'react';
import { Container } from 'reactstrap';
import { ArcaHttpSystem } from '../code/ArcaHttpSystem';
import { ArcaComponent } from './pages/ArcaComponent';
import { Banner } from './Banner';

export class Layout extends ArcaComponent {

    constructor(props) {
        super(props);

        this.state = {
        };
    }
    
    render() {
        return (
            <div className='entirePage'>
                <Banner />

                {ArcaHttpSystem.IsSmartphone
                    ? <Container id='Layout' fluid style={{ padding: 0 }} className='phone-layout-top-pos' >
                        {this.props.children}
                    </Container>
                    : <Container id='Layout' className='layout-top-pos' >
                        {this.props.children}
                    </Container>}
            </div >
        );
    }
}
